export enum RuleType {
  no,
  young,
  littleSenior,
  junior
}
